export const handleChangeDataVisitHistoryPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_VISIT_HISTORY', name, value
});